import React from 'react'
import SingleAnalyticsHeader from '../student/SingleAnalyticsHeader'
import { useTranslation } from 'react-i18next'
import CounsellorCardWidget from './CounsellorCardWidget'
import CounsellorAnalyticsWidgets from './CounsellorAnalyticsWidgets'
import { usePageTitle } from '../../../utils/util'
import { useAnalyticsUrlFilters } from '../useAnalyticsUrlFilters'
import CounsellorAnalyticsLayout from '../CounsellorAnalyticsLayout'

function CounsellorAnalyticsHome() {
    const { t } = useTranslation()
    const { selectedOptions, setSelectedOptions, daysFilter, setDaysFilter } = useAnalyticsUrlFilters()
    usePageTitle('Upstrive Education - Counsellor Analytics')

    return (
        <CounsellorAnalyticsLayout
            header={<SingleAnalyticsHeader />}
            title={t('Counsellor analytics')}
            card={<CounsellorCardWidget setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} />}
            daysFilter={daysFilter}
            setDaysFilter={setDaysFilter}
        >
            <CounsellorAnalyticsWidgets selectedOptions={selectedOptions} daysFilter={daysFilter} setDaysFilter={setDaysFilter} />
        </CounsellorAnalyticsLayout>
    )
}

export default CounsellorAnalyticsHome
